<template>
    <template v-for="(app, index) in appList" v-bind:key="index">
        <template v-if="0 == index">
            <div style="height: 12px;"></div>
        </template>
        <template v-else>
            <!-- 二つ目以降はセパレータを入れる(マージンはセパレータ分小さくしておく) -->
            <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP"></div>
            <div style="height: 12px;"></div>
        </template>

        <div class="scv-app-box">
            <img class="scv-app-icon" :src="app.artworkUrl60">
            <div class="scv-app-info-box">
                <div class="scv-app-detail-link-text scv-text-default-color-main-FRONTENDEX-MOBILE-APP" @click="onDetailDisplay(app)">{{app.trackName}}</div>
                <div class="scv-app-version-text scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">バージョン {{app.version}}</div>
                <div class="scv-app-version-text scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">リリース日 {{app.currentVersionReleaseDate}}</div>
            </div>
            <div class="ms-auto scv-update-install-btn-box">
                <templete v-if="!app.isRequestInstallUpdate">
                    <button type="button"
                            class="scv-btn-design-FRONTENDEX-MOBILE-APP scv-btn-color-gray-FRONTENDEX-MOBILE-APP scv-btn-size-s-FRONTENDEX-MOBILE-APP scv-install-btn-size"
                            @click="onBtnInstallUpdate(app)"
                            v-bind:disabled="(isInstall && app.isInstalled) || (!isInstall && !app.hasUpdateAvailable && '0B' != app.fileSizeBytes)">
                        <template v-if="isInstall">
                            <template v-if="app.isInstalled">
                                <span>インストール済み</span>
                            </template>
                            <template v-else>
                                <span>インストール</span>
                            </template>

                        </template>
                        <template v-else>
                            <span>アップデート</span>
                        </template>

                    </button>
                </templete>
                <template v-else>
                    <div class="scv-install-btn-size d-flex justify-content-center align-items-center">
                        <div class="scv-spinner-border-FRONTENDEX-MOBILE-APP scv-app-list-spinner-border spinner-border"></div>
                    </div>
                </template>
            </div>

        </div>
        <div style="height: 12px;"></div>
    </template>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { AppInfo } from '@/models/AppCatalog/AppInfo';

    @Options({
        props: {
            appList: { type: Array, required: true },   // クラス：AppInfo
            isInstall: { type: Boolean, required: true},
        },
        emits: [
            /**
             * @brief	詳細表示が押下
             * @param	AppInfo: 押下対象
             */
            "onDetailDisplay"

            /**
             * @brief	「アップデート」ボタン「インストール」ボタンが押下
             * @param	AppInfo: 押下対象
             */
            ,"onInstallUpdate"
        ]
    })

    export default class AppCatalogList extends Vue {
        private isInstall!: boolean;

        /**
         * 「アップデート」ボタン「インストール」ボタンが押下
         */
        private onBtnInstallUpdate(app: AppInfo): void {
            this.$emit("onInstallUpdate", app);
        }

        /**
         * 「詳細表示」ボタンが押下
         */
        private onDetailDisplay(app: AppInfo): void {
            this.$emit("onDetailDisplay", app);
        }
    }
</script>

<style scoped>
    /* アプリ情報 */
    .scv-app-box {
        min-height: 56px; /* 上下マージン(12px, 12px)と合わせて80px*/
        display: flex;
        flex-direction: row;
    }

    /* アプリアイコン */
    .scv-app-icon {
        height: 56px;
        min-width: 56px;
        border-radius: 13px;
        border: 0.5px solid #E6EBF0;
    }

    /* アプリ情報欄 */
    .scv-app-info-box {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
    }

    /* アプリバージョン */
    .scv-app-version-text {
        font-size: 11px;
        line-height: 1.2;
        margin-bottom: 4px;
    }

    /* アプリ名 */
    .scv-app-detail-link-text {
        font-size: 14px;
        color: #007AFF;
        /* バージョン情報との間 */
        line-height: 1.2;
        margin-bottom: 8px;
    }

    /* アップデート・インストールボタンのエリア */
    .scv-update-install-btn-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 16px;
        min-width: max-content; /* ボタンサイズよりは小さくならないように */
    }

    /* インストール/アップデートボタンサイズ */
    .scv-install-btn-size {
        min-width: 96px;
        height: 24px;
    }

    /* くるくる更新アイコン */
    .scv-app-list-spinner-border {
        width: 24px;
        height: 24px;
    }
</style>